import { render } from "./HomeInfo.vue?vue&type=template&id=3bd838f2"
import script from "./HomeInfo.vue?vue&type=script&lang=js"
export * from "./HomeInfo.vue?vue&type=script&lang=js"

import "./HomeInfo.vue?vue&type=style&index=0&id=3bd838f2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__